import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class IntegrationMovementService {
  constructor(client) {
    this.client = client;
  }

  async findAll({
    companyIds,
    holdingName,
    subholdingName,
    brokerId,
    rut,
    movementTypeId,
    stateIds,
    fullname,
    movementStartDate,
    movementEndDate,
    createdStartDate,
    createdEndDate,
    page,
    size
  }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/integrations/movements`,
      {
        params: {
          companyIds,
          holdingName,
          subholdingName,
          brokerId,
          rut,
          movementTypeId,
          stateIds,
          fullname,
          movementStartDate,
          movementEndDate,
          createdStartDate,
          createdEndDate,
          page,
          size
        }
      }
    );
    return response.data;
  }

  async findOne(id) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/integrations/movements/${id}`
    );
    return response.data;
  }

  async getTypes() {
    const response = await this.client.get(
      `${apiPrefix}${v2}/integrations/movement-types`
    );
    return response.data;
  }

  async getStates() {
    const response = await this.client.get(
      `${apiPrefix}${v2}/integrations/movement-states`
    );
    return response.data;
  }

  async setAsManaged(id, { comment }) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/integrations/movements/${id}/set-as-managed`,
      { comment }
    );
    return response.data;
  }

  async setAsNotConsidered(id, { comment }) {
    const response = await this.client.post(
      `${apiPrefix}${v2}/integrations/movements/${id}/set-as-not-considered`,
      { comment }
    );
    return response.data;
  }
}
